<template>
  <div class="honor-control-container">
    <el-card class="container-card" shadow="hover">
      <el-form :inline="true" :model="searchForm" label-position="right" label-width="80px" class="search-form"
        style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px; overflow-x: auto;">

        <el-form-item label="用户标识" size="small" style="display: flex;align-items: center;">
          <el-input v-model="searchForm.userId" placeholder="请输入用户标识" clearable style="width: 200px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch" plain>搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" icon="el-icon-refresh" @click="resetSearch" plain>重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" size="small" @click="batchUpdate" :disabled="selection.length === 0">
            批量修改({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="small" @click="exportExcel" :disabled="selection.length === 0">
            导出选中项
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-upload action="" :auto-upload="false" :on-change="handleExcelImport" accept=".xlsx,.xls"
            :show-file-list="false" style="display: inline-block;">
            <el-button type="primary" size="small">导入Excel</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="text" size="small" @click="downloadTemplate">下载模板</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="multipleTable" :data="tableData" border stripe style="width: 100%" v-loading="loading"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)" class="data-table"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55" align="center"></el-table-column>

        <el-table-column prop="id" label="ID" width="80" align="center" header-align="center"></el-table-column>
        <el-table-column prop="userId" label="用户标识" width="220" align="center" header-align="center"></el-table-column>

        <el-table-column prop="upProbability" label="设置概率(%)" width="200" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.upProbability" :min="0" :max="100" size="mini"
              @change="handleProbabilityChange(scope.row)">
            </el-input-number>
          </template>
        </el-table-column>

        <el-table-column prop="reportedCount" label="已上报数" width="180" align="center"
          header-align="center"></el-table-column>
        <el-table-column prop="totalCount" label="总数" width="180" align="center"
          header-align="center"></el-table-column>
        <el-table-column prop="upRate" label="上报率" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="eventType" label="上报行为" width="180" align="center" header-align="center">
          <template slot-scope="scope">
            {{ getEventTypeLabel(scope.row.eventType) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="540" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)"
              plain>编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)"
              plain>删除</el-button>
            <el-button size="mini" type="primary" plain @click="generateHandle(scope.row)">生成点击链接</el-button>
            <el-button size="mini" type="info" icon="el-icon-search" plain
              @click="openClickQueryDialogByRow(scope.row)">查询未上报数据</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" background small>
        </el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="handleDialogClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="用户标识" prop="userId">
            <el-input v-model="form.userId" placeholder="请输入用户标识" :disabled="isEditMode"></el-input>
          </el-form-item>
          <el-form-item label="设置概率(%)" prop="upProbability">
            <el-input v-model="form.upProbability" placeholder="请输入设置概率(%)"></el-input>
          </el-form-item>
          <el-form-item label="上报行为" prop="eventType">
            <el-select v-model="form.eventType" placeholder="请选择上报行为">
              <el-option label="激活" value="10001"></el-option>
              <el-option label="拉活" value="10022"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="批量修改设置" :visible.sync="batchDialogVisible" width="30%">
        <el-form label-width="100px">
          <el-form-item label="上报概率(%)">
            <el-input-number v-model="batchForm.upProbability" :min="0" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item label="上报行为">
            <el-select v-model="batchForm.eventType">
              <el-option label="激活" value="10001"></el-option>
              <el-option label="拉活" value="10022"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="batchDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmBatchUpdate">确认</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="generateDialog" width="700px">
        <el-form :model="form2">
          <el-form-item>
            <div style="width: 100%;">
              <el-input v-model="form2.url" placeholder="请输入生成的链接" clearable
                style="width: 80%; display: inline-block; vertical-align: middle;" />
              <el-button type="primary" @click="fuzhicopy"
                style="display: inline-block; vertical-align: middle; margin-left: 10px;">
                复制
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="未上报数据" :visible.sync="clickQueryDialogVisible" width="80%" @closed="handleClickDialogClosed">
        <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 10px;">
          <span>已选择 {{ clickQuerySelection.length }} 项</span>
          <el-button type="primary" size="small" :disabled="clickQuerySelection.length === 0 || clickUpSubmitting"
            @click="manualUpSelectedClicks">手动上报选中</el-button>
          <el-button type="warning" size="small" :disabled="clickQueryRows.length === 0 || clickUpSubmitting"
            @click="manualUpAllPageClicks">上报当前页全部</el-button>
        </div>
        <el-table :data="clickQueryRows" border stripe v-loading="clickQueryLoading"
          @selection-change="handleClickSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="id" label="ID" width="120" align="center" />
          <el-table-column prop="userUuid" label="用户标识" min-width="220" align="center" />
          <el-table-column prop="advertiserId" label="广告主ID" min-width="160" align="center" />
          <el-table-column prop="creativeId" label="创意ID" min-width="180" align="center" />
          <el-table-column prop="eventTime" label="事件时间" min-width="220" align="center">
            <template slot-scope="scope">{{ formatEventTime(scope.row.eventTime) }}</template>
          </el-table-column>
          <el-table-column prop="ip" label="IP" min-width="160" align="center" />
        </el-table>
        <div style="margin-top: 12px; text-align: right;">
          <el-pagination @size-change="handleClickSizeChange" @current-change="handleClickCurrentChange"
            :current-page="clickQueryPagination.current" :page-sizes="[10, 20, 50, 100]"
            :page-size="clickQueryPagination.size" layout="total, sizes, prev, pager, next, jumper"
            :total="clickQueryPagination.total" />
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '../../until/controlRequest'
import { exportJsonToExcel } from '../../until/export2Excel'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'HonorClickControl',
  data() {
    return {
      generateDialog: false,
      form2: {},
      searchForm: {
        userId: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增控制信息',
      form: {
        id: null,
        userId: '',
        upProbability: '',
        eventType: '10001'
      },
      rules: {
        userId: [
          { required: true, message: '请输入用户标识', trigger: 'blur' }
        ],
        upProbability: [
          { required: true, message: '请输入设置概率(%)', trigger: 'blur' },
          {
            validator: this.validateProbability,
            trigger: 'blur'
          }
        ]
      },
      isEditMode: false,

      selection: [],
      batchDialogVisible: false,
      batchForm: {
        upProbability: 50,
        eventType: '10001'
      },
      clickLinks: {}
      ,clickQueryDialogVisible: false
      ,clickQueryLoading: false
      ,clickUpSubmitting: false
      ,clickQueryRows: []
      ,clickQuerySelection: []
      ,clickQueryPagination: { current: 1, size: 10, total: 0 }
      ,activeClickUserUuid: ''
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {

    handleSelectionChange(val) {
      this.selection = val
    },

    batchUpdate() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      this.batchDialogVisible = true
    },

    confirmBatchUpdate() {
      const params = this.selection.map(item => ({
        id: item.id,
        userUuid: item.userUuid,
        upProbability: this.batchForm.upProbability,
        eventType: this.batchForm.eventType
      }))
      post('/v1/honor/control/batchUpdate', params)
        .then(() => {
          this.$message.success('批量修改成功')
          this.fetchPage()
          this.batchDialogVisible = false
        })
        .catch(() => {
          this.$message.error('批量修改失败')
        })
    },

    getEventTypeLabel(value) {
      const eventTypeMap = {
        '10001': '激活',
        '10022': '拉活'
      }
      return eventTypeMap[value] || value
    },

    // 概率校验方法
    validateProbability(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入设置概率(%)'));
        return;
      }

      const numValue = Number(value);

      // 检查是否为有效数字
      if (isNaN(numValue)) {
        callback(new Error('请输入有效的数字'));
        return;
      }

      // 检查是否在0-100范围内
      if (numValue < 0 || numValue > 100) {
        callback(new Error('概率值必须在0-100之间'));
        return;
      }

      // 检查小数位数是否超过两位
      const strValue = String(value);
      if (strValue.includes('.')) {
        const decimalPart = strValue.split('.')[1];
        if (decimalPart.length > 2) {
          callback(new Error('概率值最多保留两位小数'));
          return;
        }
      }

      callback();
    },

    // 新增方法 - 导出Excel
    exportExcel() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      const tHeader = ['ID', '用户标识', '设置概率(%)', '已上报数', '总数', '上报率', '上报行为', '点击链接']
      const filterVal = ['id', 'userId', 'upProbability', 'reportedCount', 'totalCount', 'upRate', 'eventType', 'clickLink']
      const data = this.selection.map(item => {
        return {
          ...item,
          eventType: this.getEventTypeLabel(item.eventType),
          clickLink: this.clickLinks[item.id] || '未生成链接'
        }
      })
      exportJsonToExcel({
        header: tHeader,
        data,
        key: filterVal,
        filename: 'HONOR控制数据_' + new Date().toLocaleDateString()
      })
    },

    generateHandle(row) {
      this.$message.success('生成成功')
      this.generateDialog = true
      const url = `https://control.zjwec.cn/api/v1/honor/click/save?fef=2000000&p=7aaaa&reqid=__REQUESTID__&os=__OS__&ip=__IP__&oaid=__OAID__&crId=__CREATIVE_ID__&advId=__ADVERTISER_ID__&traId=__TRACK_ID__&time=__TIME__&ua=__UA__&kehu=${row.userUuid}`
      this.form2.url = url
      this.$set(this.clickLinks, row.id, url)
    },

    openClickQueryDialogByRow(row) {
      const userUuid = row && (row.userUuid || row.userId)
      if (!userUuid) {
        this.$message.warning('该行缺少用户标识')
        return
      }
      this.activeClickUserUuid = userUuid
      this.clickQueryDialogVisible = true
      this.clickQueryPagination.current = 1
      this.fetchClickQuery()
    },

    fetchClickQuery() {
      this.clickQueryLoading = true
      const params = {
        current: this.clickQueryPagination.current,
        size: this.clickQueryPagination.size,
        userUuid: this.activeClickUserUuid
      }
      get('/v1/honor/click/query', params)
        .then(data => {
          this.clickQueryRows = (data && data.records) || []
          this.clickQueryPagination.total = (data && data.total) || 0
          this.clickQueryPagination.size = (data && data.size) || this.clickQueryPagination.size
          this.clickQueryPagination.current = (data && data.current) || this.clickQueryPagination.current
          this.clickQuerySelection = []
        })
        .finally(() => {
          this.clickQueryLoading = false
        })
    },

    handleClickSelectionChange(val) {
      this.clickQuerySelection = val
    },

    handleClickSizeChange(val) {
      this.clickQueryPagination.size = val
      this.clickQueryPagination.current = 1
      this.fetchClickQuery()
    },

    handleClickCurrentChange(val) {
      this.clickQueryPagination.current = val
      this.fetchClickQuery()
    },

    async manualUpSelectedClicks() {
      if (this.clickQuerySelection.length === 0) {
        this.$message.warning('请先选择要上报的数据')
        return
      }
      const userUuid = this.activeClickUserUuid || (this.clickQuerySelection[0] && this.clickQuerySelection[0].userUuid) || ''
      if (!userUuid) {
        this.$message.warning('缺少用户标识')
        return
      }
      const ids = this.clickQuerySelection.map(r => r.id)
      try {
        this.clickUpSubmitting = true
        const res = await post('/v1/honor/click/up', { userUuid, ids })
        this.$message.success(res || '上报成功')
      } catch (e) {
      } finally {
        this.clickUpSubmitting = false
      }
    },

    async manualUpAllPageClicks() {
      if (!this.clickQueryRows || this.clickQueryRows.length === 0) {
        this.$message.warning('当前页没有可上报的数据')
        return
      }
      const userUuid = this.activeClickUserUuid || (this.clickQueryRows[0] && this.clickQueryRows[0].userUuid) || ''
      if (!userUuid) {
        this.$message.warning('缺少用户标识')
        return
      }
      const ids = this.clickQueryRows.map(r => r.id)
      try {
        this.clickUpSubmitting = true
        const res = await post('/v1/honor/click/up', { userUuid, ids })
        this.$message.success(res || '上报成功')
      } catch (e) {
      } finally {
        this.clickUpSubmitting = false
      }
    },

    handleClickDialogClosed() {
      this.clickQuerySelection = []
      this.activeClickUserUuid = ''
    },

    formatEventTime(ts) {
      const n = Number(ts)
      if (!n || isNaN(n)) return ts
      try {
        return new Date(n).toLocaleString()
      } catch (e) {
        return ts
      }
    },

    handleProbabilityChange(row) {
      post('/v1/honor/control/update', {
        id: row.id,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: row.eventType
      }).then(() => {
        this.$message.success('概率更新成功')
      })
    },

    handleTypeChange(row) {
      post('/v1/honor/control/update', {
        id: row.id,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: row.eventType
      }).then(() => {
        this.$message.success('转化类型更新成功')
      })
    },


    async fuzhicopy() {
      try {
        await navigator.clipboard.writeText(this.form2.url);
        this.$message.success('复制成功');
      } catch (err) {
        console.error('复制失败', err);
        this.$message.error('复制失败，请手动复制');
      }
    },
    fetchPage() {
      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        userId: this.searchForm.userId
      }
      get('/v1/honor/control/page', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchPage()
    },
    resetSearch() {
      this.searchForm = {
        userId: ''
      }
      this.handleSearch()
    },
    handleAdd() {
      this.dialogTitle = '新增控制信息'
      this.form = {
        id: null,
        userId: '',
        upProbability: '',
        eventType: '10001'
      }
      this.isEditMode = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑控制信息'
      this.form = {
        id: row.id,
        userId: row.userId,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: String(row.eventType),
      }
      this.isEditMode = true
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const api = this.form.id ? '/v1/honor/control/update' : '/v1/honor/control/insert'
        post(api, this.form)
          .then(() => {
            this.$message.success(this.form.id ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error(this.form.id ? '更新失败' : '新增失败')
          })
      })
    },
    handleDelete(row) {
      this.$confirm(`确定要删除用户标识为 "${row.userId}" 的控制信息吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/v1/honor/control/delete?userUuid=${row.userUuid}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },

    // 添加下载模板功能
    downloadTemplate() {
      // 定义模板表头
      const header = [
        ['用户标识', '设置概率(%)', '上报行为']
      ];

      // 创建工作表
      const worksheet = XLSX.utils.aoa_to_sheet(header);

      // 创建工作簿
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '模板');

      // 写入并生成文件
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      // 触发下载
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'HONOR控制数据导入模板.xlsx');
    },

    // 添加Excel导入功能
    handleExcelImport(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          // 处理导入的数据
          if (jsonData.length === 0) {
            this.$message.warning('Excel文件中没有数据');
            return;
          }

          // 转换数据格式
          const importData = jsonData.map(item => ({
            userId: item['用户标识'] || '',
            upProbability: item['设置概率(%)'] || '',
            eventType: this.getEventTypeValue(item['上报行为']) || '10001'
          }));

          // 过滤掉空数据
          const validData = importData.filter(item =>
            item.userId && item.userId.trim() !== '');

          if (validData.length === 0) {
            this.$message.warning('Excel文件中没有有效的数据');
            return;
          }

          // 批量保存数据
          this.batchSaveImportData(validData);
        } catch (error) {
          console.error('Excel解析错误:', error);
          this.$message.error('Excel文件解析失败，请检查文件格式');
        }
      };
      reader.readAsArrayBuffer(file.raw);
      return false; // 阻止默认上传行为
    },

    // 根据标签获取事件类型值
    getEventTypeValue(label) {
      const eventTypeMap = {
        '激活': '10001',
        '拉活': '10022'
      };
      return eventTypeMap[label] || label;
    },

    // 批量保存导入的数据
    batchSaveImportData(dataList) {
      this.$confirm(`确定要导入 ${dataList.length} 条数据吗？`, '导入确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post('/v1/honor/control/batchInsert', dataList)
          .then(response => {
            this.fetchPage();
          })
          .catch(() => {
            this.$message.error('导入失败');
          });
      }).catch(() => {
        this.$message.info('已取消导入');
      });
    }
  }
}
</script>

<style scoped>
.honor-control-container {
  padding: 20px;
}

.container-card {
  min-height: calc(100vh - 90px);
}

.search-form {
  margin-bottom: 20px;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}

.el-button--warning {
  margin-left: 10px;
}

.el-button--success {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/honor/HonorClickControl.vue